import * as api from '../api';

export const getAssetTemplates = (args) => {
  const {
    options: { siteId },
  } = args;
  return api.callGet(`/manager/sites/${siteId}/asset-templates`, args);
};

export const getAssetTemplate = (args) => {
  const {
    data: { id },
  } = args;
  return api.callGet(`/manager/asset-templates/${id}`, args);
};

export const postAssetTemplate = (args) => {
  const {
    options: { siteId },
  } = args;
  return api.callPost(`/manager/sites/${siteId}/asset-templates`, args);
};

export const patchAssetTemplate = (args) => {
  const {
    data: { id },
  } = args;
  return api.callPatch(`/manager/asset-templates/${id}`, args);
};

export const archiveAssetTemplate = (args) => {
  const {
    data: { id },
  } = args;
  return api.callPost(`/manager/asset-templates/${id}/archive`, { options: args.options });
};

export const unarchiveAssetTemplate = (args) => {
  const {
    data: { id },
  } = args;
  return api.callPost(`/manager/asset-templates/${id}/unarchive`, { options: args.options });
};

export const linkTemplateSite = (args) => {
  const {
    data: { id },
  } = args;
  return api.callPost(`/manager/asset-templates/${id}/sites`, args);
};

export const unlinkTemplateSite = (args) => {
  const {
    data: { id, siteId },
  } = args;
  return api.callDelete(`/manager/asset-templates/${id}/sites/${siteId}`, {
    options: args.options,
  });
};

export const linkTemplateGroup = (args) => {
  const {
    data: { id },
  } = args;
  return api.callPost(`/manager/asset-templates/${id}/groups`, args);
};

export const unlinkTemplateGroup = (args) => {
  const {
    data: { id, assetGroupId },
  } = args;
  return api.callDelete(`/manager/asset-templates/${id}/groups/${assetGroupId}`, {
    options: args.options,
  });
};

export const linkTemplateItem = (args) => {
  const {
    data: { id },
  } = args;
  return api.callPost(`/manager/asset-templates/${id}/items`, args);
};

export const unlinkTemplateItem = (args) => {
  const {
    data: { id, assetItemId },
  } = args;
  return api.callDelete(`/manager/asset-templates/${id}/items/${assetItemId}`, {
    options: args.options,
  });
};

export const getTaskTemplates = (args) => {
  const {
    data: { assetTemplateId },
  } = args;
  return api.callGet(`/manager/asset-templates/${assetTemplateId}/task-templates`, args);
};

export const getTaskTemplate = (args) => {
  const {
    data: { assetTemplateId, id },
  } = args;
  return api.callGet(`/manager/asset-templates/${assetTemplateId}/task-templates/${id}`, args);
};

export const postTaskTemplate = (args) => {
  const {
    data: { assetTemplateId },
  } = args;
  return api.callPost(`/manager/asset-templates/${assetTemplateId}/task-templates`, args);
};

export const patchTaskTemplate = (args) => {
  const {
    data: { assetTemplateId, id },
  } = args;
  return api.callPatch(`/manager/asset-templates/${assetTemplateId}/task-templates/${id}`, args);
};

export const archiveTaskTemplate = (args) => {
  const {
    data: { assetTemplateId, id },
  } = args;
  return api.callPost(`/manager/asset-templates/${assetTemplateId}/task-templates/${id}/archive`, {
    options: args.options,
  });
};

export const unarchiveTaskTemplate = (args) => {
  const {
    data: { assetTemplateId, id },
  } = args;
  return api.callPost(
    `/manager/asset-templates/${assetTemplateId}/task-templates/${id}/unarchive`,
    { options: args.options }
  );
};

export const getTemplateInventories = (args) => {
  const {
    data: { assetTemplateId },
  } = args;
  return api.callGet(`/manager/asset-templates/${assetTemplateId}/inventories`, args);
};

export const linkTemplateInventory = (args) => {
  const {
    data: { assetTemplateId },
  } = args;
  return api.callPost(`/manager/asset-templates/${assetTemplateId}/inventories`, args);
};

export const unlinkTemplateInventory = (args) => {
  const {
    data: { assetTemplateId, inventoryId },
  } = args;
  return api.callDelete(`/manager/asset-templates/${assetTemplateId}/inventories/${inventoryId}`, {
    options: args.options,
  });
};

export const getAssetGroups = (args) => {
  const {
    options: { siteId },
  } = args;
  return api.callGet(`/manager/sites/${siteId}/asset-groups`, args);
};

export const getAssetGroup = (args) => {
  const {
    options: { siteId },
    data: { id },
  } = args;
  return api.callGet(`/manager/sites/${siteId}/asset-groups/${id}`, args);
};

export const postAssetGroup = (args) => {
  const {
    options: { siteId },
  } = args;
  return api.callPost(`/manager/sites/${siteId}/asset-groups`, args);
};

export const patchAssetGroup = (args) => {
  const {
    options: { siteId },
    data: { id },
  } = args;
  return api.callPatch(`/manager/sites/${siteId}/asset-groups/${id}`, args);
};

export const archiveAssetGroup = (args) => {
  const {
    options: { siteId },
    data: { id },
  } = args;
  return api.callPost(`/manager/sites/${siteId}/asset-groups/${id}/archive`, {
    options: args.options,
  });
};

export const unarchiveAssetGroup = (args) => {
  const {
    options: { siteId },
    data: { id },
  } = args;
  return api.callPost(`/manager/sites/${siteId}/asset-groups/${id}/unarchive`, {
    options: args.options,
  });
};

export const addGroupChild = (args) => {
  const {
    options: { siteId },
    data: { id },
  } = args;
  return api.callPost(`/manager/sites/${siteId}/asset-groups/${id}/children`, args);
};

export const removeGroupChild = (args) => {
  const {
    options: { siteId },
    data: { id, childGroupId },
  } = args;
  return api.callDelete(`/manager/sites/${siteId}/asset-groups/${id}/children/${childGroupId}`, {
    options: args.options,
  });
};

export const linkGroupItem = (args) => {
  const {
    options: { siteId },
    data: { id },
  } = args;
  return api.callPost(`/manager/sites/${siteId}/asset-groups/${id}/items`, args);
};

export const unlinkGroupItem = (args) => {
  const {
    options: { siteId },
    data: { id, assetItemId },
  } = args;
  return api.callDelete(`/manager/sites/${siteId}/asset-groups/${id}/items/${assetItemId}`, {
    options: args.options,
  });
};

export const getGroupTaskOccurrences = (args) => {
  const {
    options: { siteId },
    data: { id },
  } = args;
  return api.callGet(`/manager/sites/${siteId}/asset-groups/${id}/task-occurrences`, args);
};

export const getAssetItems = (args) => {
  const {
    options: { siteId },
  } = args;
  return api.callGet(`/manager/sites/${siteId}/asset-items`, args);
};

export const getAssetItem = (args) => {
  const {
    options: { siteId },
    data: { id },
  } = args;
  return api.callGet(`/manager/sites/${siteId}/asset-items/${id}`, args);
};

export const postAssetItem = (args) => {
  const {
    options: { siteId },
  } = args;
  return api.callPost(`/manager/sites/${siteId}/asset-items`, args);
};

export const patchAssetItem = (args) => {
  const {
    options: { siteId },
    data: { id },
  } = args;
  return api.callPatch(`/manager/sites/${siteId}/asset-items/${id}`, args);
};

export const archiveAssetItem = (args) => {
  const {
    options: { siteId },
    data: { id },
  } = args;
  return api.callPost(`/manager/sites/${siteId}/asset-items/${id}/archive`, {
    options: args.options,
  });
};

export const unarchiveAssetItem = (args) => {
  const {
    options: { siteId },
    data: { id },
  } = args;
  return api.callPost(`/manager/sites/${siteId}/asset-items/${id}/unarchive`, {
    options: args.options,
  });
};

export const linkItemSite = (args) => {
  const {
    options: { siteId },
    data: { id },
  } = args;
  return api.callPost(`/manager/sites/${siteId}/asset-items/${id}/sites`, args);
};

export const unlinkItemSite = (args) => {
  const {
    options: { siteId },
    data: { id, targetSiteId },
  } = args;
  return api.callDelete(`/manager/sites/${siteId}/asset-items/${id}/sites/${targetSiteId}`, {
    options: args.options,
  });
};

export const getAssetMaintenance = (args) => {
  const {
    options: { siteId },
  } = args;
  return api.callGet(`/manager/sites/${siteId}/asset-maintenance`, args);
};

export const getAssetMaintenanceItem = (args) => {
  const {
    options: { siteId },
    data: { assetItemId },
  } = args;
  return api.callGet(`/manager/sites/${siteId}/asset-maintenance/${assetItemId}`, args);
};

export const postAssetMaintenance = (args) => {
  const {
    options: { siteId },
  } = args;
  return api.callPost(`/manager/sites/${siteId}/asset-maintenance`, args);
};

export const patchAssetMaintenance = (args) => {
  const {
    options: { siteId },
    data: { assetItemId },
  } = args;
  return api.callPatch(`/manager/sites/${siteId}/asset-maintenance/${assetItemId}`, args);
};

export const archiveAssetMaintenance = (args) => {
  const {
    options: { siteId },
    data: { assetItemId },
  } = args;
  return api.callPost(`/manager/sites/${siteId}/asset-maintenance/${assetItemId}/archive`, {
    options: args.options,
  });
};

export const unarchiveAssetMaintenance = (args) => {
  const {
    options: { siteId },
    data: { assetItemId },
  } = args;
  return api.callPost(`/manager/sites/${siteId}/asset-maintenance/${assetItemId}/unarchive`, {
    options: args.options,
  });
};

export const getTaskOccurrences = (args) => {
  const {
    options: { siteId },
  } = args;
  return api.callGet(`/manager/sites/${siteId}/task-occurrences`, args);
};

export const getTaskOccurrence = (args) => {
  const {
    options: { siteId },
    data: { id },
  } = args;
  return api.callGet(`/manager/sites/${siteId}/task-occurrences/${id}`, args);
};

export const postTaskOccurrence = (args) => {
  const {
    options: { siteId },
  } = args;
  return api.callPost(`/manager/sites/${siteId}/task-occurrences`, args);
};

export const postEnsureTaskOccurrence = (args) => {
  const {
    options: { siteId },
  } = args;
  return api.callPost(`/manager/sites/${siteId}/task-occurrences/ensure`, args);
};

export const patchTaskOccurrence = (args) => {
  const {
    options: { siteId },
    data: { id },
  } = args;
  return api.callPatch(`/manager/sites/${siteId}/task-occurrences/${id}`, args);
};

export const archiveTaskOccurrence = (args) => {
  const {
    options: { siteId },
    data: { id },
  } = args;
  return api.callPost(`/manager/sites/${siteId}/task-occurrences/${id}/archive`, {
    options: args.options,
  });
};

export const completeTaskOccurrence = (args) => {
  const {
    options: { siteId },
    data: { id },
  } = args;
  return api.callPatch(`/manager/sites/${siteId}/task-occurrences/${id}`, {
    ...args,
    data: { ...args.data, status: 'Completed' },
  });
};

export const assignTaskOccurrence = (args) => {
  const {
    options: { siteId },
    data: { id, employeeId },
  } = args;
  return api.callPatch(`/manager/sites/${siteId}/task-occurrences/${id}`, {
    ...args,
    data: { employeeId },
  });
};

export const getSiteInventories = (args) => {
  const {
    options: { siteId },
  } = args;
  return api.callGet(`/manager/sites/${siteId}/inventories`, args);
};

export const patchInventory = (args) => {
  const {
    options: { siteId },
    data: { id },
  } = args;
  return api.callPatch(`/manager/sites/${siteId}/inventories/${id}`, args);
};
